import React, { Fragment, useEffect, useState } from "react";
import { FaUserGear, FaXmark } from "react-icons/fa6";

import { toast } from "react-toastify";
import { putApi } from "../../services/api/globalApi";

const { forwardRef, useRef, useImperativeHandle } = React;

const AgentModal = forwardRef(
  ({ agentData, filterDataHandler, clearState }, ref) => {
    const [visible, setVisible] = useState(false);

    console.log(agentData);
    const showModal = () => {
      setVisible(!visible);
      clearState();
    };

    useImperativeHandle(ref, () => ({
      showModal() {
        setVisible(!visible);
      },
    }));

    const archiveUser = async () => {
      const path = `admin/users/${agentData?._id}/archive`;
      try {
        const response = await putApi({
          path,
        });
        console.log(response);
        toast.success("کاربر با موفقیت به آرشیو اضافه شد.", {
          position: "top-right",
          closeOnClick: true,
        });
        filterDataHandler({ page: 1 });
        showModal();
      } catch (error) {
        console.error(error);
        toast.error(error?.response?.data?.errors[0].message, {
          position: "top-right",
          closeOnClick: true,
        });
      }
    };

    return (
      <Fragment>
        <div
          className={`fixed top-0 right-[50%] w-[300px] mr-[-150px] md:w-[700px] md:mr-[-350px] mt-[5%] overflow-hidden transition-all z-[1021] rounded-3xl bg-gray-100 dark:bg-gray-800 mx-auto opacity-0 invisible ${
            visible && "mt-[10%] !visible opacity-100"
          }`}
        >
          <div className="w-full h-14 flex justify-between items-center px-4">
            <p className="flex items-center gap-x-2 text-lg text-gray-800 dark:text-white">
              <FaUserGear size={24} />
              {/* کاربر {agentData?.name || "-"} */}
            </p>
            <FaXmark
              onClick={showModal}
              size="24"
              className="text-red-500 transition-all cursor-pointer hover:scale-110"
            />
          </div>
          <div className="border-b-2 w-11/12 mx-auto"></div>
          <div className="w-full flex justify-center items-center px-6 py-6 text-gray-800 dark:text-white">
            آیا میخواهید کاربر { "-"} را در آرشیو قرار دهید ؟
          </div>

          <div className="flex gap-x-2 items-center justify-end w-full p-3">
            <button
              type="button"
              className="inline-block transition-all rounded-3xl bg-blue-600 hover:bg-blue-700 px-8 pb-2 pt-2 text-md font-medium uppercase leading-normal text-white shadow-info-3 transition duration-150 ease-in-out hover:bg-info-accent-300 hover:shadow-info-2 focus:bg-info-accent-300 focus:shadow-info-2 focus:outline-none focus:ring-0 active:bg-info-600 active:shadow-info-2 motion-reduce:transition-none dark:shadow-black/30 dark:hover:shadow-dark-strong dark:focus:shadow-dark-strong dark:active:shadow-dark-strong"
            >
              بازگشت
            </button>
            <button
              type="button"
              className="inline-block transition-all rounded-3xl bg-red-600  hover:bg-red-700 px-14 pb-2 pt-2 text-md font-medium uppercase leading-normal text-white shadow-danger-3 transition duration-150 ease-in-out hover:bg-danger-accent-300 hover:shadow-danger-2 focus:bg-danger-accent-300 focus:shadow-danger-2 focus:outline-none focus:ring-0 active:bg-danger-600 active:shadow-danger-2 motion-reduce:transition-none dark:shadow-black/30 dark:hover:shadow-dark-strong dark:focus:shadow-dark-strong dark:active:shadow-dark-strong"
            >
              آرشیو کن
            </button>
          </div>
        </div>
        <div
          onClick={showModal}
          className={`fixed top-0 right-0 w-full h-full bg-black/50 z-[1020] invisible opacity-0 ${
            visible && "!visible opacity-100"
          }`}
        ></div>
      </Fragment>
    );
  }
);
export default AgentModal;
